module.exports = __webpack_public_path__ + "static/img/agricultural2.7bcb331.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/agricultural2.jpg
// module id = DEZU
// module chunks = 18